"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/features/onboarding-checklist/components/SetupWithEdBadge";

import React, { useEffect } from "react";
import { Icon } from "@ospweb/sdk-ui";
import { trackEntryView, trackTopleftTap } from "../utils/tracking";

const I18n = I18nUtil.createScoped(Translations);

export interface SetupWithEdBadgeProps {
  /** 点击后呼出清单 Sheet */
  onPress: () => void;
  className?: string;
}

/**
 * S1.1: Header 左上角入口未完成态胶囊徽标
 * 按 Figma `UpgradePill/Content`（#109640:103245;14323:4823）：accent4 橙底 + 白字，左侧 16px aura 图标，
 * 内边距 5/8、图标与文字间距 2、圆角 46 —— 与同位置的 Upgrade / Renew 胶囊是同一套样式
 * fe-spec §4.3 第 1 行 (S1.1)
 */
export const SetupWithEdBadge: React.FC<SetupWithEdBadgeProps> = ({
  onPress,
  className,
}) => {
  useEffect(() => {
    trackEntryView("topleft");
  }, []);

  const handleClick = () => {
    trackTopleftTap();
    onPress();
  };

  return (
    <button
      type="button"
      data-testid="setup-with-ed-badge"
      data-openreplay-label="header_setup_with_ed"
      className={`inline-flex shrink-0 items-center gap-[2px] rounded-[46px] bg-content_accent4_primary px-2 py-[5px] body_bold_m text-content_inverse_primary transition-opacity hover:opacity-80 active:opacity-70 ${
        className ?? ""
      }`}
      onClick={handleClick}
      aria-label="Setup with Ed"
    >
      <Icon name="aura" size={16} aria-hidden="true" />
      <span>{I18n.t("Setup with Ed")}</span>
    </button>
  );
};
